var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-carousel',{ref:"carouselRef",attrs:{"after-change":_vm.onChange,"dots":false}},[_c('div',[_vm._t("first")],2),_c('div',[_vm._t("second")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }